import throttle from 'lodash/throttle';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';

class Accordion {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
        };
    }

    init() {
        const aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoints['screen-sm']);
        const $toggle = $(this.elem).find('.accordion__toggle');

        Accordion.setAccordionLabels($toggle, $(this.elem).find('.accordion__collapse'));
        Accordion.toggleAccordionLabels($toggle);
        Accordion.setMaxMenuHeight($toggle);

        if (this.elem.classList.contains('accordion--no-impact-on-big-screens')) {
            if (aboveBreakpoint) {
                $toggle.off('change');
                Accordion.setAccordionLabels($toggle, $(this.elem).find('.accordion__collapse'));
            }
        }

        window.addEventListener('resize', throttle(() => {
            const elements = this.elem.querySelectorAll('.accordion__toggle:checked');

            Accordion.recalculateMaxHeight(elements);

            if (this.elem.classList.contains('accordion--no-impact-on-big-screens')) {
                this.handleBreakpointCrossing($toggle, aboveBreakpoint);
            }
        }, 200));
    }

    handleBreakpointCrossing($toggle, aboveBreakpoint) {
        const $accordionCollapse = $(this.elem).find('.accordion__collapse');

        const breakpointInfo = BreakpointHelper.breakpointCrossed(
            this.breakpoints['screen-sm'], aboveBreakpoint,
        );
        aboveBreakpoint = breakpointInfo.aboveBreakpoint;
        const { breakpointCrossed } = breakpointInfo;
        $accordionCollapse.css('max-height', '');

        if (breakpointCrossed && !aboveBreakpoint) {
            $accordionCollapse.css('max-height', '0px');
            Accordion.toggleAccordionLabels($toggle);
            Accordion.setMaxMenuHeight($toggle);

            return;
        }
        if (breakpointCrossed && aboveBreakpoint) {
            $toggle.off('change');
            Accordion.setAccordionLabels($toggle, $(this.elem).find('.accordion__collapse'));
            $accordionCollapse.css('max-height', '');
        }
    }

    /**
     * set initial values for accessibility labels so they
     * will only show in the code in case js is enabled
     */
    static setAccordionLabels($toggle, $collapse) {
        if ($collapse.css('max-height') === '0px') {
            $toggle.attr('aria-expanded', 'false');
            $collapse.attr('aria-hidden', 'true');

            return;
        }

        $toggle.attr('aria-expanded', 'true');
        $collapse.attr('aria-hidden', 'false');
    }

    /**
     * change accessibility labels according to the element's state
     */
    static toggleAccordionLabels($toggle) {
        $toggle.on('change', (e) => {
            Accordion.closeOthersOnOpen(e);

            const $accordionToggle = $(e.currentTarget);
            const $accordionCollapse = $accordionToggle.parents('.accordion__item').find('.accordion__collapse');

            $accordionToggle.attr('aria-expanded', Accordion.isOpen($accordionToggle));
            $accordionCollapse.attr('aria-hidden', !Accordion.isOpen($accordionToggle));
        });
    }

    /**
     * check if accordion is open by checking the trigger state
     * @param $accordionToggle
     * @returns {*}
     */
    static isOpen($accordionToggle) {
        return $accordionToggle.is(':checked');
    }

    /**
     * close other accordions if a new one is triggered
     */
    static closeOthersOnOpen(e) {
        if (Accordion.isOpen($(e.currentTarget))) {
            const siblings = $(e.currentTarget).parents('.accordion__item').siblings();
            siblings.find('.accordion__toggle').prop('checked', false).attr('aria-expanded', 'false');
            siblings.find('.accordion__collapse').css('max-height', 0).attr('aria-hidden', 'true');
        }
    }

    static setMaxMenuHeight($toggle) {
        $toggle.on('change', (event) => {
            const $accordionCollapse = $(event.currentTarget).siblings('.accordion__collapse');
            if (event.currentTarget.checked) {
                $accordionCollapse.css('max-height', $accordionCollapse[0].scrollHeight);
                return;
            }
            $accordionCollapse.css('max-height', 0);
        });
    }

   static recalculateMaxHeight(elements) {
        if (elements.length) {
            elements.forEach((element) => {
                const accordionCollapse = element.parentNode.querySelector('.accordion__collapse');
                accordionCollapse.style.maxHeight = `${accordionCollapse.scrollHeight}px`;
            });
        }
    }
}

export default Accordion;
